export const LANGUAGE = 'lang';

export const THEME_COLOR_ACCENT = 'accent-color';
export const THEME_COLOR_DARK = 'dark-color';
export const THEME_COLOR_LIGHT = 'light-color';

export const LANG_AUTO = 'auto';
export const LANG_RU = 'ru';
export const LANG_EN = 'en';

export const THEME_DARK = 'dark';
export const THEME_LIGHT = 'light';

export const WIDGET_FONT = 'font';
export const IS_FORM_VISIBLE = 'isFormVisible';
export const IS_LOGO_HIDDEN = 'isLogoHidden';
export const IS_REGISTRATION_TITLE_HIDDEN = 'isTitleHidden';
export const IS_CALENDAR_VISIBLE = 'isCalendarVisible';
export const IS_REGISTRATION_TEXT_HIDDEN = 'isRegistrationTextHidden';
export const IS_CONFIRMATION_TEXT_HIDDEN = 'isConfirmationTextHidden';
export const IS_CONFIRMATION_TITLE_HIDDEN = 'isConfirmationTitleHidden';
export const IS_LABELS_HIDDEN = 'isLabelsHidden';
export const IS_PLACEHOLDERS_VISIBLE = 'isPlaceholdersVisible';
export const PARENT_URL = 'parentUrl';

export const REGISTRATION_BUTTON_TITLE_RU = 'registrationButtonTitleRu';
export const REGISTRATION_BUTTON_TITLE_EN = 'registrationButtonTitleEn';

export const DEFAULT_CONFIRMATION_TITLE = (accessPreModeration, eventName) => {
    return accessPreModeration
        ? `Спасибо, ваша заявка на "${eventName}" принята!`
        : `Поздравляем, вы успешно зарегистрированы на мероприятие "${eventName}"!`
};

export const DEFAULT_CONFIRMATION_TEXT = (accessPreModeration, email='{user_email}') => {
    return accessPreModeration
        ? `После одобрения заявки организаторами мероприятия вы получите подтверждение участия на электронный адрес ${email}, указанный в форме регистрации. Если вы не можете найти письмо, проверьте папку Спам или свяжитесь с поддержкой support@comdi.com.`
        : `Подтверждение участия отправлено на электронный адрес ${email}, указанный в форме регистрации. Если вы не можете найти письмо, проверьте папку Спам или свяжитесь с поддержкой support@comdi.com.`
};
